import React, { useEffect } from 'react';

import RiskSummary from '../Charts/Department/RiskSummary';
import ActionStatus from '../Charts/Department/ActionStatus';
import TopRisks from '../Charts/Department/TopRisks';
import Matrix from '../Charts/Department/Matrix';


import { connect } from "react-redux";
import { compose } from "redux";

import { getDepartmentDashboardData } from "../../store/actions/dashboardActions";

const DepartmentDashboard = (props) => {

    const { department_id, department_dashboard_data, getDepartmentDashboardDataFN, setDepartmentDashboardData } = props;

    useEffect(() => {
        //console.log("Use effect rgigered!");
        getDepartmentDashboardDataFN(department_id);
    }, [department_id, getDepartmentDashboardDataFN]);

    useEffect(() => {
        // Update parent state whenever department_dashboard_data changes
        setDepartmentDashboardData(department_dashboard_data);
    }, [department_dashboard_data, setDepartmentDashboardData]);

   ////console.log(department_dashboard_data);

    return (

        <div className="flex flex-col" style={{ minHeight: `calc(100vh - 245px)` }}>
            {/* First Row: Three Equal Columns */}
            <div className="flex flex-grow w-full">


                <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">
                   
                    <div className="bg-[#3b3b3b] text-white px-4 py-2 flex-none flex items-center justify-center rounded-tl-[5px] rounded-tr-[5px] border-b border-gray-300">
                        <div className="flex justify-center items-center gap-1 flex-nowrap overflow-hidden">
                        <h2 className="text-base sm:text-xs md:text-xs lg:text-base font-bold items-center text-ellipsis whitespace-nowrap m-0">
                                Risk Summary
                            </h2>

                        </div>

                    </div>

                    <div className="contents">
                        <RiskSummary height={(window.innerHeight - 450) / 2} data={department_dashboard_data.risk_summary} />
                    </div>
                </div>


                <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">


                <div className="bg-[#3b3b3b] text-white px-4 py-2 flex-none flex items-center justify-center rounded-tl-[5px] rounded-tr-[5px] border-b border-gray-300">
                        <div className="flex justify-center items-center gap-1 flex-nowrap overflow-hidden">
                        <h2 className="text-base sm:text-xs md:text-xs lg:text-base font-bold items-center text-ellipsis whitespace-nowrap m-0">
                                Action Status
                            </h2>

                        </div>

                    </div>

                    <div className="contents">
                        <ActionStatus height={(window.innerHeight - 550) / 2} data={department_dashboard_data.action_status} />
                    </div>


                </div>
                <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">


                <div className="bg-[#3b3b3b] text-white px-4 py-2 flex-none flex items-center justify-center rounded-tl-[5px] rounded-tr-[5px] border-b border-gray-300">
                        <div className="flex justify-center items-center gap-1 flex-nowrap overflow-hidden">
                        <h2 className="text-base sm:text-xs md:text-xs lg:text-base font-bold items-center text-ellipsis whitespace-nowrap m-0">
                                Top Risks     
                            </h2>

                        </div>

                    </div>

                    <div className="contents p-2">
                        <TopRisks height={(window.innerHeight - 450) / 2} data={department_dashboard_data.top_5_risks} />

                    </div>



                </div>
            </div>

            {/* Second Row: Two Columns (2/3 and [30%]) */}
            <div className="flex flex-grow w-full mt-4">

                <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">
                    <div className="bg-[#3b3b3b] text-white px-4 py-2 flex-none flex items-center justify-center rounded-tl-[5px] rounded-tr-[5px] border-b border-gray-300">
                        <div className="flex justify-center items-center gap-1 flex-nowrap overflow-hidden">
                        <h2 className="text-base sm:text-xs md:text-xs lg:text-base font-bold items-center text-ellipsis whitespace-nowrap m-0">
                        Inherent Risk Distribution

                            </h2>

                        </div>

                    </div>

                    <div className="contents p-2">
                        <Matrix height={(window.innerHeight - 450) / 2} data={department_dashboard_data.inherent_matrix} which="inherent" />
                    </div>
                </div>


                <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">

                    <div className="bg-[#3b3b3b] text-white px-4 py-2 flex-none flex items-center justify-center rounded-tl-[5px] rounded-tr-[5px] border-b border-gray-300">

                        <div className="flex justify-center items-center gap-1 flex-nowrap overflow-hidden">

                        <h2 className="text-base sm:text-xs md:text-xs lg:text-base font-bold items-center text-ellipsis whitespace-nowrap m-0">
                        Residual Risk Distribution

                            </h2>

                        </div>


                    </div>

                    <div className="contents p-2 pb-0">
                        <Matrix height={(window.innerHeight - 450) / 2} data={department_dashboard_data.residual_matrix} which="residual" />
                    </div>
                </div>


                <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">

                    <div className="bg-[#3b3b3b] text-white px-4 py-2 flex-none flex items-center justify-center rounded-tl-[5px] rounded-tr-[5px] border-b border-gray-300">

                        <div className="flex justify-center items-center gap-1 flex-nowrap overflow-hidden">

                        <h2 className="text-base sm:text-xs md:text-xs lg:text-base font-bold items-center text-ellipsis whitespace-nowrap m-0">
                        Future Risk Distribution
                            </h2>

                        </div>


                    </div>

                    <div className="contents p-2 pb-0">
                        <Matrix height={(window.innerHeight - 450) / 2} data={department_dashboard_data.future_matrix} which="future" />
                    </div>
                </div>


            </div>

        </div>



    );



};

const mapStateToProps = (state) => {
    console.log("Data", state)
    return {

        department_dashboard_data: state.dashboard.department_dashboard_data,


    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDepartmentDashboardDataFN: (department_id) => dispatch(getDepartmentDashboardData(department_id)),

    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(DepartmentDashboard);


